export const DASHBOARD_LAYOUT_STORAGE_KEY = 'sellerclub.dashboardLayout';

export const DASHBOARD_LAYOUT_CLASSIC = 'classic';
export const DASHBOARD_LAYOUT_BETA = 'beta';

export function readDashboardLayoutPreference() {
  try {
    const v = localStorage.getItem(DASHBOARD_LAYOUT_STORAGE_KEY);
    if (v === DASHBOARD_LAYOUT_BETA || v === DASHBOARD_LAYOUT_CLASSIC) return v;
  } catch {
    /* ignore */
  }
  return DASHBOARD_LAYOUT_BETA;
}

export function writeDashboardLayoutPreference(layout) {
  try {
    localStorage.setItem(DASHBOARD_LAYOUT_STORAGE_KEY, layout);
  } catch {
    /* ignore */
  }
}
